/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-09-27 15:25:36
 * @LastEditors: linxi
 * @LastEditTime: 2023-01-12 10:53:15
 */
import { Button, Popover, Space, TableColumnType, Tag, Tooltip } from 'antd'
import { QuestionCircleTwoTone } from '@ant-design/icons'
import React, { ReactElement } from 'react'
import { decrypt } from '../../models/m'
import { getTypesName, getPayTypesName } from '../../models/membersPage'
import styles from './MembersManagementPage.module.css'
import moment from 'moment'
import { DateTimeFormatSimples } from '../../models/datetime'
import { getMaskPhone } from '../../models/phone'
import { Checks } from '../../models/setting'

const getProcuctInfo = (item: any, settings: any) => {
  const materialsCategory = item.materialsCategory;
  const packSpec = item.packSpec ? item.packSpec : "-";
  const doseCategory = item.doseCategory ? item.doseCategory : "-";
  const tenantSupplierName = item.tenantSupplierName
    ? item.tenantSupplierName
    : "-";
  const spec = item.spec ? item.spec : "-";
  const model = item.model ? item.model + "/" : "";
  if (settings?.[Checks.MLKG] == 1) {
    if (materialsCategory == "0") {
      return packSpec + "/" + doseCategory + "/" + tenantSupplierName;
    } else if (materialsCategory == "1" || materialsCategory == "2") {
      return packSpec + "/" + model + tenantSupplierName;
    } else {
      return packSpec + "/" + tenantSupplierName;
    }
  } else {
    if (materialsCategory == "0") {
      return packSpec + "/" + doseCategory + "/" + tenantSupplierName;
    } else if (materialsCategory == "1" || materialsCategory == "2") {
      return spec + "/" + model + tenantSupplierName;
    } else {
      return spec + "/" + tenantSupplierName;
    }
  }
};

export const Columns = (
  onClick: (text: string, obj: any) => void,
  startIndex: number,
  QXData?: boolean,
  sortedInfo?: any
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      width: '3rem',
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '患者姓名',
      dataIndex: 'memberName',
      align: 'center',
      key: 'memberName',
      sorter: true,
      sortOrder: (sortedInfo?.columnKey === 'memberName' || sortedInfo?.field === 'memberName') ? sortedInfo?.order : null,
    },
    {
      title: '手机号',
      dataIndex: 'memberPhone',
      align: 'center',
      key: 'memberPhone',
      render: (_, r) => (r?.memberPhone ? !QXData ? getMaskPhone(decrypt(r?.memberPhone)) :decrypt(r?.memberPhone) : '-'),
    },
    {
      title: '会员卡号',
      dataIndex: 'cardNo',
      align: 'center',
      key: 'cardNo',
      sorter: true,
      sortOrder: (sortedInfo?.columnKey === 'cardNo' || sortedInfo?.field === 'cardNo') ? sortedInfo?.order : null,
      render: (_, r) => (r?.cardNo ? decrypt(r?.cardNo) : '-'),
    },
    {
      title: '标签',
      dataIndex: 'name',
      align: 'center',
      key: 'labelList',
      render: function element(_, t) {
        return (
          <Space>
            {t.labelList.map((item: any) => {
              return (
                <Tooltip key={item.id} placement='top' title={item.name}>
                  <span
                    className={styles.label}
                    style={{ color: `${item.fontColor}`, backgroundColor: `${item.backgroundColor}`, borderRadius: '50%' }}
                  >
                    {item.headName}
                  </span>
                </Tooltip>
              )
            })}
          </Space>
        )
      },
    },
    {
      title: '当前余额',
      dataIndex: 'balanceMoney',
      align: 'center',
      key: 'balanceMoney',
      sorter: true,
      sortOrder: (sortedInfo?.columnKey === 'balanceMoney' || sortedInfo?.field === 'balanceMoney') ? sortedInfo?.order : null,
      render: (_, r) => r.balanceMoney?.toFixed(2),
    },
    {
      title: '开卡时间',
      dataIndex: 'createTime',
      align: 'center',
      key: 'createTime',
      sorter: true,
      sortOrder: (sortedInfo?.columnKey === 'createTime' || sortedInfo?.field === 'createTime') ? sortedInfo?.order : null,
    },
    {
      title: '操作员',
      dataIndex: 'realname',
      align: 'center',
      key: 'realname',
    },

    {
      title: '操作',
      align: 'center',
      dataIndex: 'id',
      key: 'id',
      render: function Actions(_, t): ReactElement | undefined {
        return (
          <Space style={{ lineHeight: 0 }}>
            <p className={styles.tableText} onClick={() => onClick('topUp', t)}>
              充值
            </p>
            <p
              className={styles.tableText}
              onClick={() => onClick('topUpRecord', t)}
            >
              充值记录
            </p>
            <p
              className={styles.tableText}
              onClick={() => onClick('refund', t)}
            >
              退款
            </p>
            <p
              className={styles.tableText}
              onClick={() => onClick('edit', t)}
            >
              编辑
            </p>
            <p
              className={styles.tableText}
              onClick={() => onClick('detail', t)}
            >
              详情
            </p>
          </Space>
        )
      },
    },
  ]
}
export const TopUpRecordModalColumns = (
  startIndex: number,
  type?: number // '' 会员管理-充值记录  1.会员信息详情
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      width: '3rem',
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: ` ${type == 1 ? '充值金额' : '交易金额'}`,
      dataIndex: 'traderMoney',
      align: 'center',
      key: 'traderMoney',
      render: (_, r) =>
        r.type == 1 || r.type == 2
          ? '-' + r.traderMoney?.toFixed(2)
          : r.traderMoney?.toFixed(2),
    },
    {
      title: '账户余额',
      dataIndex: 'accountMoney',
      align: 'center',
      key: 'accountMoney',
      render: (_, r) => r.accountMoney?.toFixed(2),
    },
    {
      title: '类型',
      dataIndex: 'type',
      align: 'center',
      key: 'type',
      render: (_, r) => getTypesName(r.type),
    },
    {
      title: '支付方式',
      dataIndex: 'payType',
      align: 'center',
      key: 'payType',
      render: (_, r) => getPayTypesName(r.payType),
    },
    {
      title: '操作时间',
      dataIndex: 'updateTime',
      align: 'center',
      key: 'updateTime',
    },
    {
      title: '操作员',
      dataIndex: 'createUserName',
      align: 'center',
      key: 'createUserName',
    },

    {
      title: '备注',
      align: 'center',
      dataIndex: 'remarks',
      key: 'remarks',
      ellipsis: true,
    },
  ]
}

export const detailColumns = (startIndex: number): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      width: '3rem',
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '刷卡人',
      dataIndex: 'traderName',
      align: 'center',
      key: 'traderName',
    },
    {
      title: '交易金额',
      dataIndex: 'traderMoney',
      align: 'center',
      key: 'traderMoney',
      render: (_, r) =>
        r.type == 1 || r.type == 2
          ? '-' + r.traderMoney?.toFixed(2)
          : r.traderMoney?.toFixed(2),
    },
    {
      title: '账户余额',
      dataIndex: 'accountMoney',
      align: 'center',
      key: 'accountMoney',
      render: (_, r) => r.accountMoney?.toFixed(2),
    },
    {
      title: '项目',
      dataIndex: 'itemName',
      align: 'center',
      key: 'itemName',
    },
    {
      title: '操作时间',
      dataIndex: 'updateTime',
      align: 'center',
      key: 'updateTime',
    },
    {
      title: '操作员',
      dataIndex: 'createUserName',
      align: 'center',
      key: 'createUserName',
    },

    // {
    //   title: "备注",
    //   align: "center",
    //   dataIndex: "remarks",
    //   key: "remarks",
    //   ellipsis: true

    // },
  ]
}

export const MemberBenefitsColumns = (
  onClick: (text: string, obj: any) => void, 
  startIndex: number,
  settings: any,
): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      width: '3rem',
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '项目名称',
      align: 'left',
      ellipsis:true,
      width: '20rem',
      render: function Element(_, t) {
        const info = t.catalogType == 0 ? getProcuctInfo(t, settings) : ''
        return (
          <Popover
            content={
              <div>
                <span style={{ fontSize: '16px', fontWeight: 'bolder', paddingRight: '15px' }}>
                  {t.name}
                </span>
                <span style={{ color: '#999999', fontSize: '14px' }}>
                  {info}
                </span>
              </div>
            }
            placement="bottom"
          >
            <div style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
              <span style={{ fontSize: '16px', fontWeight: 'bolder', paddingRight: '15px' }}>
                {t.name}
              </span>
              <span style={{ color: '#999999', fontSize: '14px' }}>
                {info}
              </span>
            </div>
          </Popover>
        )
      },
    },
    {
      title: '目录售价',
      dataIndex: 'retailPrice',
      align: 'center',
      key: 'retailPrice',
      width: '6rem',
      render: (_, r) => r.retailPrice != null ? Number(r.retailPrice).toFixed(5) : '',
    },
    {
      title: (
        <Space size={4}>
          折扣类型
          <Popover
            content={
              <div style={{ width: '375px' }}>
                <p>折扣价：根据开方时选择的商品的售价进行计算，如果是按照忽略库存或者合并批次开方则会员价=目录售价*折扣；如果是按照批次开方则会员价=该批次售价*折扣；</p>
                <p>特价：选择了特价后开方时固定取会员价格</p>
              </div>

            }
            placement='top'
            title='说明'
          >
            <QuestionCircleTwoTone />
          </Popover>
        </Space>
      ),
      dataIndex: 'discountType',
      align: 'center',
      key: 'discountType',
      width: '6rem',
      render: function DiscountTypeCell(_, r) {
        if (r.billingCategory) {
          return `折扣（例外 ${r.specialNum || 0} 个）`
        }
        return r.discountType == 1 ? '特价' : '折扣'
      },
    },
    {
      title: '会员价',
      dataIndex: 'price',
      align: 'center',
      key: 'price',
      width: '6rem',
      colSpan: 2,
      render: function PriceCell(_, r) {
        if (!(r.price >= 0)) return ''
        const num = parseFloat(r.price)
        const displayValue = r.discountType == 1
          ? num.toFixed(5)
          : String(Math.round(num))
        if (!r.retailPrice || parseFloat(r.retailPrice) <= 0) {
          return displayValue
        }
        const retailPrice = parseFloat(r.retailPrice)
        let popoverContent: string
        if (r.discountType == 1) {
          const ratio = Math.round((num / retailPrice) * 100)
          popoverContent = `折扣比例：${ratio}%`
        } else {
          const discounted = (retailPrice * num / 100).toFixed(5)
          popoverContent = `折后价：${discounted}元`
        }
        return (
          <Popover content={popoverContent} overlayClassName={styles.pricePopover}>
            <span>{displayValue}</span>
          </Popover>
        )
      },
    },
    {
      dataIndex: 'unit',
      align: 'center',
      key: 'unit',
      width: '4rem',
      colSpan: 0,
      render: function UnitCell(_, r) {
        return r.discountType == 1 ? '元' : '%'
      },
    },
    {
      title: '操作',
      align: 'center',
      dataIndex: 'id',
      key: 'id',
      width: '6rem',
      render: function Actions(_, t): ReactElement {
        return (
          <Space style={{ lineHeight: 0 }}>
            <Button
              type='link'
              size='small'
              onClick={() => onClick('edit', t)}
            >
              编辑
            </Button>
            <Button
              type='link'
              size='small'
              onClick={() => onClick('delete', t)}
            >
              删除
            </Button>
          </Space>
        )
      },
    },
  ]
}

export const MemberCardColumns = (onClick: (text: string, obj: any) => void, startIndex: number, QXData?: any): TableColumnType<any>[] => {
  return [
    {
      title: '序号',
      key: 'no',
      align: 'center',
      width: '3rem',
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '会员卡号',
      dataIndex: 'cardNo',
      width: '8rem',
      align: 'center',
      ellipsis: true,
      key: 'cardNo',
      render: (_, r) => r.cardNo ? r.cardNo : '-',
    },
    {
      title: '会员卡金额',
      dataIndex: 'balance',
      width: '8rem',
      align: 'center',
      ellipsis: true,
      key: 'balance',
      render: (_, r) => r.balance > 0 ? r.balance : '-',
    },
    {
      title: '操作员',
      dataIndex: 'createUserName',
      width: '8rem',
      align: 'center',
      ellipsis: true,
      key: 'createUserName',
      render: (_, r) => r.createUserName ? r.createUserName : '-',
    },
    {
      title: '状态',
      dataIndex: 'memberId',
      width: '8rem',
      align: 'center',
      ellipsis: true,
      key: 'memberId',
      render: function Status(_: any, t: any): ReactElement {
        return (
          <Space style={{ lineHeight: 0 }}>
            {t?.memberId <= 0 ? <p style={{ color: '#FFAE55' }}>待绑定</p> : <p>已绑定</p>}
          </Space>
        )
      },
    },
    {
      title: '激活时间',
      dataIndex: 'updateTime',
      width: '10rem',
      align: 'center',
      ellipsis: true,
      key: 'updateTime',
      render: (_, r) => r.updateTime ? moment(r.updateTime).format(DateTimeFormatSimples) : '-',
    },
    {
      title: '关联患者',
      dataIndex: 'memberName',
      width: '8rem',
      align: 'center',
      ellipsis: true,
      key: 'memberName',
      render: (_, r) => r.memberName ? r.memberName : '-',
    },
    {
      title: '患者手机号',
      dataIndex: 'memberPhone',
      width: '8rem',
      align: 'center',
      ellipsis: true,
      key: 'memberPhone',
      render: (_, r) => r.memberPhone ? (!QXData ? getMaskPhone(r.memberPhone) : r.memberPhone ) : '-',
    },
    {
      title: '备注',
      dataIndex: 'remark',
      width: '8rem',
      align: 'center',
      ellipsis: true,
      key: 'remark',
      render: (_, r) => r.remark ? r.remark : '-',
    },
    {
      title: '创建时间',
      dataIndex: 'createTime',
      width: '10rem',
      align: 'center',
      ellipsis: true,
      key: 'createTime',
      render: (_, r) => r.createTime ? moment(r.createTime).format(DateTimeFormatSimples) : '-',
    },
    {
      title: '操作',
      align: 'center',
      width: '10rem',
      dataIndex: 'id',
      key: 'id',
      render: function Actions(_, t): ReactElement | undefined {
        return (
          t?.memberId <= 0 ?
            <Space style={{ lineHeight: 0 }}>
               <Button
                type='link'
                size='small'
                onClick={() => onClick('bind', t)}
              >
                绑定
              </Button>
              <Button
                type='link'
                size='small'
                onClick={() => onClick('edit', t)}
              >
                编辑
              </Button>
              <Button
                type='link'
                size='small'
                danger
                onClick={() => onClick('delete', t)}
              >
                删除
              </Button>
            </Space> : 
            <Space style={{ lineHeight: 0 }}>
              <Button
                type='link'
                size='small'
                danger
                onClick={() => onClick('unbind', t)}
              >
                解绑
              </Button>
            </Space>
        )
      },
    },
  ]
}

